import cn from 'classnames';
import { FC, useEffect, useState } from 'react';
import { envStrToBoolean, setBodyOverflow } from 'src/helpers/utils';
import { useIsModuleLoaded } from 'src/hooks/use-is-module-loaded';
import { useSessionRecorder } from 'src/hooks/use-session-recorder';
import './styles.scss';

// Define a functional component named 'Gos'
const FunMission: FC = () => {
  const moduleName = 'fun-mission';
  const isLoaded = useIsModuleLoaded(moduleName);
  const [fullScreen] = useState(false);
  const sessionRecorder = useSessionRecorder();

  useEffect(() => {
    if (!isLoaded) return;

    window.__gdlib?.registerCallBack('scrollLock', 'funMission', (value: 'set' | 'unset') => {
      setBodyOverflow(value === 'set' ? 'unset' : 'set');
    });
  }, [isLoaded]);

  useEffect(() => {
    if (!isLoaded) return;
    // Function to attempt starting the widget
    const startWidget = (): any => {
      if (!window.__gdlib) {
        return <div>...</div>;
      }

      window.__gdlib.startFunWidget({
        parentId: 'funMissionId', // ID for the widget's parent element
        customClassName: cn('frame', { ['fullScreen']: fullScreen }), // Custom class name for styling
        sdk: !envStrToBoolean(process.env.REACT_APP_FUN_MISSION_FRAME),
      });
      return true; // Indicate that the widget has been started
    };

    // Attempt to start the widget immediately
    if (startWidget()) {
      return () => {
        // Close the widget when the component is unmounted
        window.__gdlib?.closeWidget(moduleName);
      };
    } // Exit if the widget was started

    // If the widget is not yet available, set up a MutationObserver to wait for changes in the DOM
    const observer = new MutationObserver(() => {
      // Check again if the widget can be started
      if (startWidget()) {
        observer.disconnect(); // Stop observing once the widget is successfully started
      }
    });

    // Start observing for changes in the DOM
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup function to be called on component unmount
    return () => {
      // Close the widget when the component is unmounted
      window.__gdlib?.closeWidget(moduleName);
      observer.disconnect(); // Clean up the observer to prevent memory leaks
    };
  }, [isLoaded]);

  useEffect(() => {
    sessionRecorder?.trackEvent('Fun mission page view');
  }, []);

  // Render a div element with the specified ID for the widget
  return <div id="funMissionId" className="fun-mission fullWidth page_content" />;
};

export default FunMission;
